<template>
  <form ref="form" :action="url" method="POST" target="_blank">
    <input v-for="(value, key) in params" :key="key" :value="value" :name="key" hidden>
    <Button @click="submit">
      Оплатить
    </Button>
  </form>
</template>

<script>

import Button from '@/components/Button';

export default {
  name: 'PaymentFormRobokassa',
  components: { Button },
  props: {
    url: { type: String, required: true },
    params: { type: Object, required: true },
    autosubmit: { type: Boolean, default: false },
  },
  computed: {
  },
  mounted() {
    if (this.autosubmit) {
      this.$nextTick(this.submit);
    }
  },
  methods: {
    submit() {
      this.$refs.form.submit();
    }
  }
};
</script>
